<template>
  <div class="dbs_info" style="padding-bottom: 5%">
    <img
      v-if="park.Corporation.code == 'DOCOMO' && park.park_info"
      class="port_img"
      :src="park.park_info.image_url"
    />
    <CycleInfo
      label="営業時間"
      :value="
        park.AdditionalInformation.OpeningTime.start ==
        park.AdditionalInformation.OpeningTime.end
          ? '24時間'
          : park.AdditionalInformation.OpeningTime.start +
            '-' +
            park.AdditionalInformation.OpeningTime.end
      "
    />
    <CycleInfo
      v-if="park.Corporation.code == 'DOCOMO' && park.plan_info"
      label="料金"
      :value="
        park.plan_info.term1.basic.basic_charge +
        '円/' +
        park.plan_info.term1.basic.basic_period +
        '分'
      "
    />
  </div>
</template>

<script>
export default {
  name: "DbsParkInfoLower",
  props: {
    park: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.dbs_info {
  line-height: 40px;
  padding-bottom: 5%;
}

.port_img {
  margin: auto;
  display: block;
  margin-bottom: 5%;
  width: 50%;
}
</style>
